import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Switch from "react-switch";

import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { admin_update_new_subscription_for_vendor } from "../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import store from "../../../../../../store/store";
import { UPDATE_SUBSCRIPTION_TYPE } from "../../../../../../store/types";
import { Button, Image } from "react-bootstrap";

export const CasualDiningSeatingManagementScreen = (props) => {
  const history = useHistory();
  const [state, setState] = useState({
    casualSeatingGenral: false,
    casualSeatingWalkinWaitlist: false,
    casualSeatingReservation: false,
    casualSeatingTableManagement: false,
  });

  const onClickCasualSeatingGenral = (e) => {
    if (state.casualSeatingGenral === true && !e) {
      setState({
        ...state,
        casualSeatingGenral: !state.casualSeatingGenral,
      });
    } else {
      history.push({
        pathname: "/admin-casual-dining/seatingmanagement/generalseating",
        state: e,
      });
    }
  };

  const onClickCasualSeatingWalkinWaitlist = (e) => {
    if (state.casualSeatingWalkinWaitlist === true && !e) {
      setState({
        ...state,
        casualSeatingWalkinWaitlist: !state.casualSeatingWalkinWaitlist,
      });
    } else {
      history.push({
        pathname: "/admin-casual-dining/seatingmanagement/walkinwaitlist",
        state: e,
      });
    }
  };

  const onClickCasualSeatingReservation = (e) => {
    if (state.casualSeatingReservation === true && !e) {
      setState({
        ...state,
        casualSeatingReservation: !state.casualSeatingReservation,
      });
    } else {
      history.push({
        pathname: "/admin-casual-dining/seatingmanagement/reservation",
        state: e,
      });
    }
  };

  const onClickCasualSeatingTableManagement = (e) => {
    if (state.casualSeatingTableManagement === true && !e) {
      setState({
        ...state,
        casualSeatingTableManagement: !state.casualSeatingTableManagement,
      });
    } else {
      history.push({
        pathname: "/admin-casual-dining/seatingmanagement/table",
        state: e,
      });
    }
  };

  const insideSeatingSubmitClick = () => {
    let valueData = {
      value:
        state.casualSeatingGenral === false &&
        state.casualSeatingWalkinWaitlist === false &&
        state.casualSeatingReservation === false &&
        state.casualSeatingTableManagement
          ? false
          : true,
    };
    const token = props?.auth?.user?.accessToken;
    const subscriptionId = props?.subscription?._id;
    let formData = props?.allSubscriptionsData;
    formData.casual_dining_status.seating.general_seating.value =
      state.casualSeatingGenral;
    formData.casual_dining_status.seating.walkin_waitlist.value =
      state.casualSeatingWalkinWaitlist;
    formData.casual_dining_status.seating.reservation.value =
      state.casualSeatingReservation;
    formData.casual_dining_status.seating.table_management.value =
      state.casualSeatingTableManagement;
    formData.casual_dining_status.seating.value = valueData.value;
    props.admin_update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Seating subscription changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.push("/subscription");
  };

  useEffect(() => {
    const generalSeating = {
      ...(props?.subscriptionData && props?.subscriptionData.general_seating),
    };
    const walkinWaitlist = {
      ...(props?.subscriptionData && props?.subscriptionData.walkin_waitlist),
    };
    const reservation = {
      ...(props?.subscriptionData && props?.subscriptionData.reservation),
    };
    const tableManagement = {
      ...(props?.subscriptionData && props?.subscriptionData.table_management),
    };
    setState({
      casualSeatingGenral: !isEmpty(generalSeating)
        ? generalSeating.value
        : false,
      casualSeatingWalkinWaitlist: !isEmpty(walkinWaitlist)
        ? walkinWaitlist.value
        : false,
      casualSeatingReservation: !isEmpty(reservation)
        ? reservation.value
        : false,
      casualSeatingTableManagement: !isEmpty(tableManagement)
        ? tableManagement.value
        : false,
    });
  }, [props?.subscriptionData]);
  const [disabled, setDisable] = useState(
    props &&
      props?.history &&
      props?.history?.location &&
      props?.history?.location?.state &&
      props?.history?.location?.state?.access === "view"
      ? true
      : false
  );

  const backButtonHandler = (e) => {
    e.preventDefault();
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.push("/subscription");
  };

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div
                // id="onboarding-scrollbar"
                className="col-12 new-subscription-onboarding-component pt-4"
              >
                {/* <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    workWithLinkORClick={true}
                    notDisplaProgressBar={true}
                    backButtonClicked={(e) => backButtonHandler(e)}
                  />
                </div>
              </Media> */}

                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={false}
                    onClick={(e) => backButtonHandler(e)}
                  />
                </Media>
                {/* <Media query="(min-width: 991px)"> */}
                <div className="col-8 onboarding_process_screen-button-map seating-section-margin-toggle-mobile inside-subscription-event-section text-break">
                  <div>
                    <TopTextReusableComponent headingText="Seating Management" />
                    <h4 className="heading-seating-top mt-4 seating-section-margin-toggle f18-700">
                      Seating Management Subscription Options and Settings
                    </h4>
                  </div>
                  <div className="row seating-section-margin-toggle ">
                    <div className="col-2 col-md-1">
                      <Switch
                        checked={state.casualSeatingGenral}
                        onChange={onClickCasualSeatingGenral}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        disabled={disabled}
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                    <div className="col-2 col-md-3 inside-event-offline-online-text mobile-p-0">
                      <div className="f14-700">General Seating</div>
                    </div>
                    <div className="col-4 col-md-5 inside-event-offline-online-text mobile-p-0">
                      <div className="f11-400 opacity5">
                        (This information has to be filled to provide details on
                        Queue Management or Seating arrangement)
                      </div>
                    </div>
                    {state.casualSeatingGenral && (
                      <div className="col-4 col-md-3">
                        <div className="d-flex ml-2">
                          <>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingGenral({ access: true })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingGenral({ access: false })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </Button>
                          </>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row seating-section-margin-toggle">
                    <div className="col-2 col-md-1">
                      <Switch
                        checked={state.casualSeatingWalkinWaitlist}
                        onChange={onClickCasualSeatingWalkinWaitlist}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        disabled={disabled}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                    <div className="col-2 col-md-3  inside-event-offline-online-text mobile-p-0">
                      <div className="f14-700">Walk-In/Wait List</div>
                    </div>
                    <div className="col-4 col-md-5 inside-event-offline-online-text mobile-p-0">
                      <div className="f11-400 opacity5">
                        (Here you can maintain settings for Walk-in/Waitlist)
                      </div>
                    </div>
                    {state.casualSeatingWalkinWaitlist && (
                      <div className="col-4 col-md-3">
                        <div className="d-flex ml-2">
                          <>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingWalkinWaitlist({
                                  access: true,
                                })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingWalkinWaitlist({
                                  access: false,
                                })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </Button>
                          </>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row seating-section-margin-toggle">
                    <div className="col-2 col-md-1">
                      <Switch
                        checked={state.casualSeatingReservation}
                        onChange={onClickCasualSeatingReservation}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        disabled={disabled}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                    <div className="col-2 col-md-3  inside-event-offline-online-text  mobile-p-0">
                      <div className="f14-700">Reservations</div>
                    </div>
                    <div className="col-4 col-md-5  inside-event-offline-online-text  mobile-p-0">
                      <div className="f11-400 opacity5">
                        (Here you can maintain the settings for any Reservation
                        if you accept advance Or same day reservations)
                      </div>
                    </div>
                    {state.casualSeatingReservation && (
                      <div className="col-4 col-md-3">
                        <div className="d-flex ml-2">
                          <>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingReservation({
                                  access: true,
                                })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingReservation({
                                  access: false,
                                })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </Button>
                          </>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row seating-section-margin-toggle">
                    <div className="col-2 col-md-1">
                      <Switch
                        checked={state.casualSeatingTableManagement}
                        onChange={onClickCasualSeatingTableManagement}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        disabled={disabled}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                    <div className="col-2 col-md-3 inside-event-offline-online-text mobile-p-0">
                      <div className="f14-700">Table Management</div>
                    </div>
                    <div className="col-4 col-md-5 inside-event-offline-online-text mobile-p-0">
                      <div className="f11-400 opacity5">
                        (Here you can maintain settings for table and seat
                        management)
                      </div>
                    </div>
                    {state.casualSeatingTableManagement && (
                      <div className="col-4 col-md-3">
                        <div className="d-flex ml-2">
                          <>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingTableManagement({
                                  access: true,
                                })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickCasualSeatingTableManagement({
                                  access: false,
                                })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </Button>
                          </>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="onboarding-map-setup-screen-autodetect-button ">
                    <ReusableOnboardingButton
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      buttonType="button"
                      onClick={(e) => backButtonHandler(e)}
                    />
                    {!disabled && (
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Done"
                        buttonType="button"
                        disabled={disabled}
                        onClick={insideSeatingSubmitClick}
                      />
                    )}
                  </div>
                </div>
                {/* </Media> */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

CasualDiningSeatingManagementScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  admin_update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  subscription:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  subscriptionData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.seating,
  allSubscriptionsData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  admin_update_new_subscription_for_vendor,
})(withRouter(CasualDiningSeatingManagementScreen));
